import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { MessageService } from '../message.service';
import { ManagementService } from '../management.service';
import { Job } from '../job';

@Component({
    selector: 'app-job-detail',
    templateUrl: './job-detail.component.html',
    styleUrls: ['./job-detail.component.scss'],
    standalone: true,
    imports: [RouterModule]
})
export class JobDetailComponent implements OnInit {

  jobId: string;
  job: Job;

  private route: ActivatedRoute = inject(ActivatedRoute);
  private managementService: ManagementService = inject(ManagementService);
  private messageService: MessageService = inject(MessageService);

  ngOnInit(): void {
    this.jobId = this.route.snapshot.paramMap.get('id');
    this.messageService.set(`Viewing deadletter job ${this.jobId}...`);
    this.managementService.getDeadletterJob(this.jobId)
        .subscribe(job => {
          this.job = job;
          this.managementService.getDeadletterJobStackTrace(this.jobId)
            .subscribe(stacktrace => this.job.stackTrace = stacktrace );
        });
  }

}
